export default __webpack_public_path__ + "static/media/page1Image3.13ceffaf.jpg";